import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "data-cy": "table_source_icon"
    }
  }, [_vm.icon ? [_c(VIcon, {
    attrs: {
      "size": "16",
      "alt": _vm.name,
      "title": _vm.name
    }
  }, [_vm._v("fal fa-" + _vm._s(_vm.icon))])] : _vm.image ? [_c(VAvatar, {
    attrs: {
      "size": "16"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": _vm.name,
      "title": _vm.name
    }
  })])] : _vm._e(), _vm.showName ? [_vm._v("  " + _vm._s(_vm.name))] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };